import { useCallback, useState } from "react";

export type ModalHookResult = {
  isOpen: boolean;
  modalDetails: any;
  openModal: (details?: any) => void;
  closeModal: () => void;
};

export type DefaultModalState = {
  isOpen: false;
  openModal: () => null;
  closeModal: () => null;
};

export const useModalState = (defaultIsOpen = false): ModalHookResult => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);
  const [modalDetails, setModalDetails] = useState();

  const handleOpen = useCallback((details?: any) => {
    setIsOpen(true);

    if (details) {
      setModalDetails(details);
    }
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setModalDetails(undefined);
  }, []);

  return {
    isOpen,
    modalDetails,
    openModal: handleOpen,
    closeModal: handleClose,
  };
};
